import { Injectable, Injector } from '@angular/core';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
/*
  Generated class for the GlobalProvider provider.
*/

@Injectable({
  providedIn: 'root'
})


export abstract class GTMService {
  public abstract initGtmDom();

  public abstract newCustomerRegistered();
  
  public abstract feedier(info: Object, path: string, lang: string);
}


//PRODUCTION GTM SERVICE
export class GTMServiceProd implements GTMService {
  gtmService: GoogleTagManagerService
  constructor(
    injector: Injector
  ) 
  {
    //inject service dynamically to avoid passing the service in the constructor
    this.gtmService = injector.get<GoogleTagManagerService>(GoogleTagManagerService);
  }
  public initGtmDom() {
    this.gtmService.addGtmToDom();
  }

  public newCustomerRegistered() {
    const newCustomerTag = {
        event: "newCustomerRegistered"
    }
    this.gtmService.pushTag(newCustomerTag);
  }
  
  public feedier(info: Object, path: string, lang: string) {
    const feedier = {
        event: "UserAttribute",
        path : path,
        langCode: lang,
        value: info
    }
    this.gtmService.pushTag(feedier);
  }
}


//DEV GTM SERVICE
export class GTMServiceDev implements GTMService {

  constructor() { }
  public initGtmDom() {
    return;
  }

  public newCustomerRegistered() {
    return;
  }
  
  public feedier(info: Object,path: string, lang: string) {
    return;
  }
  
  
  
}
